module.exports = __webpack_public_path__ + "assets/img/Main material (1).7ae96dc8.jpg";